export enum SalutationEnum {
  family = 'Familie',
  female = 'Frau',
  male = 'Herr',
  none = 'none',
}

export enum ProbateEnum {
  probateDocu = 'Dokumentation zusenden',
  probateGuide = 'Ratgeber zusenden',
  probateContact = 'persönliches Gespräch',
}

export enum CheckBoxLinkTypEnum {
  agb = 'AGB',
  newsletter = 'Newsletter',
}
